import { z } from "zod";
const FreeSchema = z.object({
    x: z.number(),
    y: z.number(),
    points: z.array(z.number()),
    label: z.string(),
    color: z.string(),
});
const SquareSchema = z.object({
    x: z.number(),
    y: z.number(),
    width: z.number(),
    height: z.number(),
    label: z.string(),
    color: z.string(),
});
const AnnotationSchema = z.union([FreeSchema, SquareSchema]);
const ChevalSchema = z.object({
    discipline: z.string().optional(),
    objectif: z.string().optional(),
    veterinarian: z.string().optional(),
    previousHoofCare: z.string().optional(),
    etatCorporel: z.number().nullable(),
});
const PiedSchema = z.object({
    fourchetteEpine: z.number().nullable(),
    sole: z.number().nullable(),
    talon: z.number().nullable(),
    barres: z.number().nullable(),
    quartiers: z.number().nullable(),
    pince: z.number().nullable(),
    cartilagesCoussinet: z.number().nullable(),
    pouls: z.number().nullable(),
    pinceSonder: z.number().nullable(),
});
const PiedsSchema = z.object({
    AD: PiedSchema,
    AG: PiedSchema,
    PD: PiedSchema,
    PG: PiedSchema,
});
export const spectrumUtilisationSchema = z.object({
    date: z.string(),
    cheval: ChevalSchema,
    environnementModeVie: z.string().optional(),
    alimentation: z.string().optional(),
    historique: z.string().optional(),
    soinsParticuliers: z.string().optional(),
    commentairesAdditionnels: z.string().optional(),
    pieds: PiedsSchema,
    ant: z
        .object({
        annotations: z.array(AnnotationSchema).optional(),
        imageData: z.string().optional(),
    })
        .optional(),
    post: z
        .object({
        annotations: z.array(AnnotationSchema).optional(),
        imageData: z.string().optional(),
    })
        .optional(),
    synthese: z.string().optional(),
    recommandations: z.string().optional(),
    signature: z.string().optional(),
    hideSpectrum: z.boolean(),
});
export const spectrumUtilisationPayloadSchema = z.object({
    date: z.string(),
    cheval: ChevalSchema,
    environnementModeVie: z.string().optional(),
    alimentation: z.string().optional(),
    historique: z.string().optional(),
    soinsParticuliers: z.string().optional(),
    commentairesAdditionnels: z.string().optional(),
    pieds: PiedsSchema,
    ant: z
        .object({
        annotations: z.array(AnnotationSchema).optional(),
        imageData: z.string().optional(),
    })
        .optional(),
    post: z
        .object({
        annotations: z.array(AnnotationSchema).optional(),
        imageData: z.string().optional(),
    })
        .optional(),
    synthese: z.string().optional(),
    recommandations: z.string().optional(),
    signature: z.string().optional(),
    hideSpectrum: z.boolean(),
});
export const podologieReportSubmissionIdSchema = z.string().uuid();
export const podologieReportSaveResultSchema = z.object({
    reportId: z.string().uuid(),
    replayed: z.boolean(),
    emailStatus: z.enum(["notRequested", "queued", "skipped", "unconfirmed"]),
});
//# sourceMappingURL=SpectrumUtilisation.js.map